<template>
  <!-- Modal -->
  <div class="modal fade" ref="returnmodal" id="ReturnArchiveModal3" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">返品情報PDF一括出力</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <vue-element-loading :active="$props.isLoading" spinner="bar-fade-scale" color="#333"/>
          <template v-if="returnPDF">
            <template v-for="(item, i) in returnPDF">
              <div :key="i" class="pdf-modal-div">
                <h6 class="font-weight-bold">{{ item.vender_name }}</h6>
                <a :href="item.url" target="_blank">PDFダウンロード</a>
              </div>
            </template>
          </template>
          <template v-else>
            <p>該当する結果がありません</p>
          </template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'ReturnArchiveModal3',
  props: [ 'returnPDF', 'isLoading' ],
  components: {
    VueElementLoading
  }
}
</script>
